import React from "react";
import { FaPlus,FaUpload,FaDownload } from "react-icons/fa";
import T from "prop-types";
import { Spinner } from "..";
import { Button } from "@mui/material";


export const SecondaryButton = ({
  text,
  className,
  onClick,
  icon,
  iconCls,
  color,
  disabled,
  isLoading,
  type
}) => 
{
  function getIcon(type){
    switch (type){
      case 1: return <FaPlus  size="15px" className={iconCls} color={color} />
      case 2: return <FaUpload size="15px" className={iconCls} color={color} />
      case 3: return <FaDownload size="15px" className={iconCls} color={color} />
    }
  }
return (
  <Button
    variant="contained"
    className={className}
    onClick={onClick}
    disabled={disabled}
    size="small"
    startIcon={ isLoading ? (
      <Spinner
        size={20}
        color="white"
        loading={isLoading}
        // style={{ marginTop: marginTop }}
      />) : (icon ? getIcon(type) : null)}
    sx={{ background: "white", color: color,fontSize:'11px' }}
    // style={{ opacity: disabled ? 0.6 : 1 }}
  >
    {text}
   
  </Button>
)};

SecondaryButton.T = {
  onClick: T.func,
  className: T.string,
  text: T.string,
  icon: T.bool,
  disabled: T.bool,
};

SecondaryButton.defaultProps = {
  onClick: null,
  className: "secButtonCls",
  text: "",
  icon: false,
  iconCls: "plusIcon",
  color: "#000",
  type:1,
};
